import "./Listing";
import "./Form";
import "./FormEmployeeWithContract";
import "./EmployeeOverview";
import "./EmployeeDocuments";
import "./EmployeeAttendanceForm";
import "./YearlyStatistics";
import "./EmployeeMaternityLeave";
import "./EmployeeMymcdForm";

import GridColumnsForm from "./modals/GridColumnsForm";
import DeleteEmployeeForm from "./modals/DeleteEmployeeForm";
import BatchDeleteEmployeesForm from "./modals/BatchDeleteEmployeesForm";
import DisableSyncEmployeeModal from "./modals/DisableSyncEmployeeModal.vue";
import DeleteEmployeeDocumentForm from "./modals/DeleteEmployeeDocumentForm.vue";
import DropdownSinglechoice from "../components/basic/DropdownSinglechoice.vue";
import DropdownMultichoice from "../components/basic/DropdownMultichoice.vue";

Vue.component('employee-grid-columns-form', GridColumnsForm);
Vue.component('delete-employee-form', DeleteEmployeeForm);
Vue.component('batch-delete-employees-form', BatchDeleteEmployeesForm);
Vue.component('disable-sync-employee-modal', DisableSyncEmployeeModal);
Vue.component('delete-employee-document-form', DeleteEmployeeDocumentForm);

Vue.component('dropdown-singlechoice', DropdownSinglechoice);
Vue.component('dropdown-multichoice', DropdownMultichoice);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/index.js